import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth-context";
import { SignOut, ChartBar, FolderOpen, User, House } from "@phosphor-icons/react";

const LOGO_URL =
  "/vznlogo.png";

export function DesignerLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const items = [
    { to: "/designer", label: "Overview", icon: ChartBar },
    { to: "/designer/projects", label: "My Projects", icon: FolderOpen },
    { to: "/account", label: "Account", icon: User },
    { to: "/", label: "Home", icon: House },
  ];

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-[#050505] text-[#fafafa] flex">
      <aside className="hidden lg:flex flex-col w-64 border-r border-[#262626] bg-[#0a0a0a] sticky top-0 h-screen">
        <Link to="/" className="px-6 py-5 border-b border-[#262626] flex items-center" data-testid="designer-brand" title="Back to home">
          <img src={LOGO_URL} alt="Vision Grafix · Back to home" className="w-[13rem] h-auto object-contain" />
        </Link>
        <nav className="flex-1 py-4">
          {items.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.to ||
              (item.to === "/designer/projects" && location.pathname.startsWith("/designer/projects"));
            return (
              <Link
                key={item.to}
                to={item.to}
                data-testid={`designer-nav-${item.label.toLowerCase().replace(" ", "-")}`}
                className={`flex items-center gap-3 px-6 py-3 text-sm border-l-2 transition-colors ${
                  isActive
                    ? "border-[#FF2D2D] bg-[#121212] text-white"
                    : "border-transparent text-[#a3a3a3] hover:text-white hover:bg-[#0f0f0f]"
                }`}
              >
                <Icon size={18} weight={isActive ? "fill" : "regular"} />
                {item.label}
              </Link>
            );
          })}
        </nav>
        <div className="p-4 border-t border-[#262626]">
          <div className="text-xs text-[#a3a3a3]">{user?.name}</div>
          <button
            onClick={handleLogout}
            className="mt-2 btn-outline px-3 py-1.5 text-xs flex items-center gap-2 w-full justify-center"
            data-testid="designer-logout"
          >
            <SignOut size={14} /> Sign out
          </button>
        </div>
      </aside>
      <div className="flex-1 min-w-0">
        <header className="lg:hidden sticky top-0 z-40 backdrop-blur-xl bg-[#050505]/70 border-b border-[#262626]">
          <div className="px-6 py-3 flex items-center justify-between">
            <img src={LOGO_URL} alt="Vision Grafix" className="w-[10rem] h-auto object-contain" />
            <button onClick={handleLogout} className="text-sm text-[#a3a3a3]">Sign out</button>
          </div>
          <nav className="flex overflow-x-auto border-t border-[#262626]">
            {items.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`px-4 py-3 text-xs whitespace-nowrap ${
                  location.pathname === item.to ? "text-[#FF2D2D]" : "text-[#a3a3a3]"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </header>
        <main className="px-6 md:px-10 py-8">{children}</main>
      </div>
    </div>
  );
}
